var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 1.65V4.4",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 6.6V9.35",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.35 5.5H28.6",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 5.5H23.65",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7861 27.6447C21.6227 26.8081 22.611 26.1388 23.6978 25.6729L25.8522 24.7495C26.9395 24.2836 27.9273 23.6143 28.7639 22.7783C29.4706 22.0715 30.0586 21.2559 30.5057 20.3616L31.35 18.7L23.5636 10.9109L22.7276 12.5835C22.2805 13.4772 21.6925 14.2934 20.9858 15.0002C20.1492 15.8367 19.1614 16.5055 18.0741 16.9714L15.9197 17.8948C14.8324 18.3607 13.8446 19.03 13.008 19.866C12.3013 20.5728 11.7128 21.389 11.2662 22.2827L10.3202 24.0702L18.15 31.9L19.0448 30.0614C19.4914 29.1671 20.0799 28.3514 20.7861 27.6447V27.6447Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 18.15H23.65V19.25H24.75V18.15Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 16.5H25.3V17.6H26.4V16.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 25.3H15.4V26.4H16.5V25.3Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 23.65H17.05V24.75H18.15V23.65Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 23.65C22.115 23.65 23.1 22.665 23.1 21.45C23.1 20.235 22.115 19.25 20.9 19.25C19.685 19.25 18.7 20.235 18.7 21.45C18.7 22.665 19.685 23.65 20.9 23.65Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7357 12.9459C19.1032 12.1066 18.2848 11.2684 17.5351 10.4357C17.2321 10.0986 17.05 9.66405 17.05 9.21085C17.05 8.84895 17.1523 8.50025 17.3437 8.19665L18.568 6.25845C18.6544 6.12205 18.7 5.9642 18.7 5.80305C18.7 5.3317 18.3183 4.95 17.847 4.95C17.3333 4.95 16.8245 5.04515 16.3438 5.22665C15.9379 5.37955 15.5062 5.5 14.85 5.5C13.3166 5.5 12.65 5.07595 12.65 4.4C12.65 3.4375 13.75 3.52935 13.75 2.75C13.75 2.16755 13.1687 1.65 12.1 1.65C10.7157 1.65 9.04642 2.3023 7.94202 2.8193C7.45692 3.0459 7.15002 3.5332 7.15002 4.0689C7.15002 4.2867 7.20172 4.5012 7.30017 4.6948L9.15532 8.34185C9.28292 8.59265 9.35002 8.8693 9.35002 9.15035C9.35057 9.5458 9.21857 9.9297 8.97712 10.2427C5.28222 15.0293 1.65002 20.0261 1.65002 24.2C1.65002 27.5413 4.11237 30.25 7.15002 30.25H13.75",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.35H17.056",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 9.35C12.5555 10.0974 11.7794 11.5456 11.3944 12.5268",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.21e28abd.svg";
export { ForwardRef as ReactComponent };